import React from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import './SyllabusNav.css';

const tabs = [
    {label: "Overview", path:"/overview"} ,
    {label: "Basic Information", path:"/basic-info"},
    {label: "Description", path:"/course-description"},
    {label: "Learning Outcomes", path: "/learning-outcomes"},
    {label: "HIPs", path: "/hips"},
    {label: "Learning Resources", path:"/learning-resources"},
    {label: "Assessment", path:"/assessment"},
    {label: "Course Schedule", path:"/course-schedule"},
    {label: "Checklist", path: "/checklist"},
];
    
    

    const SyllabusNav = ({
            onSave,
            changesDetected = false,
        }: {
            onSave?: () => void;
            changesDetected?: boolean;            
        }) => {
            
        const navigate = useNavigate();

    return (
        <nav className="syllabus-nav">
            {tabs.map((tab) => (
                <NavLink
                    key= {tab.path}  
                    onClick={async (e) => {                         
                        e.preventDefault();
                        if (changesDetected && onSave) {                            
                            const handleSave = async() => {
                                await onSave();
                                await new Promise((resolve) => setTimeout(resolve, 2500)); // wait for modal hide                              
                            }
                            await handleSave();
                            
                            //await onSave();
                            
                        }
                        //alert(tab.path);                         
                        navigate(tab.path)                        
                    }}                  
                    to={tab.path}
                    className={({isActive})=>
                        isActive ? 'nav-tab active' : 'nav-tab'
                }
                >
                    {tab.label}
                </NavLink>
            ))}
        </nav>
   );
};
export default SyllabusNav;
